import { useQuery } from '@tanstack/react-query'
import { clientProfileService, type ClientProfile } from '@/services/clientProfile'

/**
 * Neutral placeholder used only until the server responds. Deliberately not a
 * client name: a real one here would be exactly the hardcoding the client
 * profile exists to remove.
 */
const PLACEHOLDER: ClientProfile = {
  name: '',
  shortName: '',
  legalName: '',
  logoLight: '',
  logoDark: '',
  logoMark: '',
  primaryColor: '#d9b768',
  lenderLegalName: '',
  lenderName: '',
  letterheadLogo: '',
}

/** The client this deployment serves. Identity comes from the server. */
export function useClientProfile(): ClientProfile & { isLoading: boolean } {
  const { data, isLoading } = useQuery({
    queryKey: ['client-profile'],
    queryFn: () => clientProfileService.get(),
    // Deployment identity does not change during a session.
    staleTime: Infinity,
    retry: 1,
  })
  return { ...(data ?? PLACEHOLDER), isLoading }
}
